<template>
  <div class="w-100 pt-3 d-flex border-top">
    <button
      v-if="showDelete"
      type="button"
      class="btn  btn-outline-danger"
      @click="$emit('delete')"
    >
      Delete
    </button>

    <button
      class="btn btn-primary  ml-auto"
      @click="$emit('save')"
    >
      Save
    </button>
  </div>
</template>

<script>
export default {
  props: {
    showDelete: {
      required: true,
      type: Boolean,
    },
  },
}
</script>
